import { render } from "./ApiLog.vue?vue&type=template&id=4bfb67d8&scoped=true"
import script from "./ApiLog.vue?vue&type=script&lang=js"
export * from "./ApiLog.vue?vue&type=script&lang=js"

import "./ApiLog.vue?vue&type=style&index=0&id=4bfb67d8&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfb67d8"]])

export default __exports__